import { Card, CardContent, CardHeader, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface PermissionCardProps {
  title: string
  subtitle?: string
  icon?: ReactNode
  children: ReactNode
  actions?: ReactNode
  height?: string | number
  headerColor?:
    | 'primary'
    | 'secondary'
    | 'warning'
    | 'error'
    | 'info'
    | 'success'
}

export function PermissionCard({
  title,
  subtitle,
  icon,
  children,
  actions,
  height = '100%',
  headerColor = 'primary',
}: PermissionCardProps) {
  return (
    <Card
      sx={{
        height,
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <CardHeader
        sx={{
          bgcolor: `${headerColor}.50`,
          borderBottom: '1px solid',
          borderColor: 'divider',
          py: 2,
          flexShrink: 0,
        }}
        avatar={icon}
        title={
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        }
        subheader={
          subtitle && (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          )
        }
        action={actions}
      />
      <CardContent
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          p: 0,
          overflow: 'hidden',
          '&:last-child': { pb: 0 },
        }}
      >
        {children}
      </CardContent>
    </Card>
  )
}
